module.exports = __webpack_public_path__ + "static/media/share_dashboard.a27d4a7e.svg";